import React, { useState, useEffect } from "react";

const ImageHandler = ({
  src,
  alt,
  className,
  fallback,
}: {
  src: string;
  alt: string;
  className: string;
  fallback?: string;
}) => {
  const [imageError, setImageError] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(src);
  
  useEffect(() => {
    setCurrentSrc(src);
    setImageError(false);
  }, [src]);
  
  const handleImageError = () => {
    if (fallback && currentSrc !== fallback) {
      setCurrentSrc(fallback);
      setImageError(false);
    } else {
      setImageError(true);
    }
  };

  const displaySrc = currentSrc || fallback || "";

  if (imageError || (!displaySrc)) {
    return (
      <div
        className={`${className} bg-gray-300 flex items-center justify-center text-gray-500`}
        aria-label={`Image not available for ${alt}`}
      >
        Image not available
      </div>
    );
  }

  return (
    <img 
      src={displaySrc} 
      alt={alt} 
      className={className} 
      onError={handleImageError} 
    />
  );
};

export default ImageHandler;
